import { createTransform } from "redux-persist";
import { omit } from "lodash";

type ConfigurationSlice = { data?: Record<string, unknown> } | null | undefined;

function omitAnalyticsFromConfiguration(configurationSlice: ConfigurationSlice): ConfigurationSlice {
    const configurationData = configurationSlice?.data;
    if (!configurationData) return configurationSlice;
    if (!("analytics" in configurationData)) return configurationSlice;

    return { ...configurationSlice, data: omit(configurationData, "analytics") };
}

export const omitAnalyticsTransform = createTransform(
    (inboundSlice: ConfigurationSlice) => omitAnalyticsFromConfiguration(inboundSlice),
    (outboundSlice: ConfigurationSlice) => omitAnalyticsFromConfiguration(outboundSlice),
    { whitelist: ["configuration"] }
);
